import React from "react";
import { RotatingLines } from "react-loader-spinner";
import './loader.css'
const Loader = () => {
    return (
        <div className="loader">
            <RotatingLines
                visible={true}
                height="20"
                width="20"
                color="#ffffff"
                strokeWidth="3"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </div>
    );
};

export default Loader;